/* unplugin-vue-components disabled */import { render } from "./reasoning-item.vue?vue&type=template&id=332e49ba&scoped=true"
import script from "./reasoning-item.vue?vue&type=script&lang=js"
export * from "./reasoning-item.vue?vue&type=script&lang=js"

import "./reasoning-item.vue?vue&type=style&index=0&id=332e49ba&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332e49ba"],['__file',"src/components/ai-chat-v2/ai-assistant/research/reasoning-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "332e49ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('332e49ba', __exports__)) {
    api.reload('332e49ba', __exports__)
  }
  
  module.hot.accept("./reasoning-item.vue?vue&type=template&id=332e49ba&scoped=true", () => {
    api.rerender('332e49ba', render)
  })

}


export default __exports__